module.exports = "images/enfants_4.8498b2df.png";